import { inject, injectable } from 'inversify';
import { TYPES } from '@/engine/ioc';

import { type IWindowKeyboardShortcutController, KeyboardKey } from '@/engine/Controllers/interfaces.ts';
import type { IEntitiesVisibilityTogglingService } from '@/engine/keyboardShortcutServices/entitiesVisibilityToggling.service.ts';

@injectable()
export class WindowKeyboardShortcutController implements IWindowKeyboardShortcutController {
  private _isWindowKeyPressed = false;

  private readonly _entitiesVisibilityTogglingService: IEntitiesVisibilityTogglingService;

  public constructor(
    @inject(TYPES.EntitiesVisibilityTogglingService)
    entitiesVisibilityTogglingService: IEntitiesVisibilityTogglingService
  ) {
    this._entitiesVisibilityTogglingService = entitiesVisibilityTogglingService;
  }

  public init(): void {
    window.addEventListener('keydown', this.handleKeyboardEvent.bind(this));
    window.addEventListener('keyup', this.handleKeyboardEvent.bind(this));
  }

  public handleKeyboardEvent(e: KeyboardEvent): void {
    if (e.ctrlKey && e.key?.toUpperCase() === KeyboardKey.H) {
      return;
    }

    if (e.repeat) return;

    if (e.key === 'Meta') this._isWindowKeyPressed = !this._isWindowKeyPressed;

    if (this._isWindowKeyPressed) return;

    switch (e.key?.toUpperCase()) {
      case KeyboardKey.H:
        return this._entitiesVisibilityTogglingService.toggleEntitiesVisibility();
    }
  }
}
